var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('v-container',[_c('v-row',[_c('v-spacer'),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"5","lg":"5"}},[_c('PollLogin')],1),_c('v-spacer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }